import PropTypes from 'prop-types';
import config from '../../../config/index';
import { TABLET_WIDTH } from "../../../config/constants";
import labels from "../../../config/labels";
import LabelText from '../../atoms/label/LabelText';
import Image from '../../atoms/image/image';
import { CustomContainer } from '../../atoms/DependencyHelper';
import CTAButton from '../../atoms/CTAButton/CTAButton';
import { componentCheckSize } from "../../../utils/helperServices";
import styles from './emptyProductsContainer.module.scss';

const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;
const imgUrl = `${imagePrefix}/assets/images/no-filter.svg`;

const EmptyProductsContainer = (props) => {
  const { resetFilter, ctaHidden, ctaLabel, message } = props;
  const isMobile = componentCheckSize() < TABLET_WIDTH;
  const btnConfig = {
    buttonStyle: 'outline black',
    buttonText: ctaLabel || labels.lbl_reset_all_filters
  };
  const defaultLabelText = labels.upgrade.lbl_reset_desc
    .split(".")
    .filter((t)=>(t))
    .map((msg)=>(`${msg}.`));
  const displayMessageText = message
  ? (message instanceof Array ? message : [message])
  : (!isMobile ? defaultLabelText : [labels.upgrade.lbl_reset_desc]);

  return (
    <CustomContainer className={styles.emptyProductContainer}>
      <Image
        id="xbtn"
        className={styles.imageStyle}
        img_path={imgUrl}
        img_width={ctaHidden ? '80px' : '60px'}
        img_height={ctaHidden ? '80px' : '60px'}
      />
      <LabelText
        id="filter-errormessage"
        className={styles.content}
      >
        {displayMessageText && displayMessageText.map((msgText, index)=>(<div key={`msg_text_${index}`}>{msgText}</div>))}
      </LabelText>
      <CustomContainer className={styles.emptyProductResetBtn}>
        {!ctaHidden && <CTAButton
          id={`${btnConfig.buttonText}-btn`}
          className={styles.buttonStyle}
          variant={btnConfig.buttonStyle}
          handleClick={resetFilter}
          btnSizing="order-details-back-btn">
          {ctaLabel || btnConfig.buttonText}
        </CTAButton>}
      </CustomContainer>
    </CustomContainer>
  );
};

EmptyProductsContainer.propTypes = {
  resetFilter: PropTypes.func,
  ctaHidden: PropTypes.bool,
  ctaLabel: PropTypes.string,
  pageName: PropTypes.string,
  message: PropTypes.any,
};

EmptyProductsContainer.defaultProps = {
  ctaHidden: false,
  message: null,
};

export default EmptyProductsContainer;
